if (!customElements.get('count-down')) {
  customElements.define('count-down', class Countdown extends HTMLElement {
    constructor() {
      super();
      
      this.endDate = this.hasAttribute('end-date') ? new Date(this.getAttribute('end-date').replace(/-/g, "/")).toUTCString() : Date.now().toUTCString();
      this.timeElement = this.querySelector('time');
      this.id_for = this.dataset.timerFor;
      this.init();
    }

    init () {
      const countdownTime = this.getCountdownTime(this.endDate);
      if (countdownTime.total > 0) {
        this.timeInterval = setInterval(() => {
          this.renderCountdown(this.getCountdownTime(this.endDate));
        }, 1000);
      } else {
        this.setAttribute('data-ended', 'true');
        document.dispatchEvent(new CustomEvent(`countdownEnded-${this.id_for}`));
      }
    }

    getCountdownTime(endDate) {
      const total = Date.parse(endDate) - Date.parse(new Date().toUTCString());
      const _seconds = Math.floor((total / 1000) % 60);
      const _minutes = Math.floor((total / 1000 / 60) % 60);
      const _hours = Math.floor((total / (1000 * 60 * 60)) % 24);
      const days = Math.floor(total / (1000 * 60 * 60 * 24));

      let seconds = _seconds < 10 ? `0${_seconds}` : _seconds;
      let minutes = _minutes < 10 ? `0${_minutes}` : _minutes;
      let hours = _hours < 10 ? `0${_hours}` : _hours;

      return {
        total,
        days,
        hours,
        minutes,
        seconds,
      };
    }

    renderCountdown(countdownTime) {
      const daysElement = this.querySelector('.days');
      const hoursElement = this.querySelector('.hours');
      const minutesElement = this.querySelector('.minutes');
      const secondsElement = this.querySelector('.seconds');

      // daysElement.textContent = countdownTime.days;
      // hoursElement.textContent = countdownTime.hours;
      // minutesElement.textContent = countdownTime.minutes;
      // secondsElement.textContent = countdownTime.seconds;

      daysElement.querySelector('.count-down__number-seg:first-child').textContent = "0";
      daysElement.querySelector('.count-down__number-seg:last-child').textContent = countdownTime.days.toString().slice(0, 1);
      hoursElement.querySelector('.count-down__number-seg:first-child').textContent = countdownTime.hours.toString().slice(0, 1);
      hoursElement.querySelector('.count-down__number-seg:last-child').textContent = countdownTime.hours.toString().slice(1, 2);
      minutesElement.querySelector('.count-down__number-seg:first-child').textContent = countdownTime.minutes.toString().slice(0, 1);
      minutesElement.querySelector('.count-down__number-seg:last-child').textContent = countdownTime.minutes.toString().slice(1, 2);
      secondsElement.querySelector('.count-down__number-seg:first-child').textContent = countdownTime.seconds.toString().slice(0, 1);
      secondsElement.querySelector('.count-down__number-seg:last-child').textContent = countdownTime.seconds.toString().slice(1, 2);

      if(countdownTime.days <= 0) {
        // daysElement.closest('.count-down__item').classList.add('hidden');
      }

      this.timeElement.setAttribute('datetime', `P${countdownTime.days}DT${countdownTime.hours}H${countdownTime.minutes}M${countdownTime.seconds}S`);

      if (countdownTime.total <= 0) {
        clearInterval(this.timeInterval);
        this.setAttribute('data-ended', 'true');
        document.dispatchEvent(new CustomEvent(`countdownEnded-${this.id_for}`));
      }
    }
  });
}